/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { useDispatch, useSelector } from 'react-redux';
import { canEditItemForItem, getId } from '../../utils/item';
import { ConditionGlobal } from './condition.Global';
import { setOpenModales } from '../../store/global';

export const ConditionSortable = props => {
  const { id, conditionId, itemId } = props;
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id });

  const item = useSelector(state => state.items[itemId]);
  const items = useSelector(state => state.items);
  const dispatch = useDispatch();
  const [condition, setCondition] = useState(null);
  const canEdit = canEditItemForItem(item, items);

  useEffect(() => {
    if (Array.isArray(item?.conditions)) {
      const entry = item.conditions.find(
        conditionObj => getId(conditionObj) === conditionId
      );
      setCondition(entry?.[conditionId]);
    } else {
      setCondition(null);
    }
  }, [item?.conditions, conditionId]);

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
  };

  if (!condition) {
    return null;
  }

  return (
    <div
      ref={setNodeRef}
      {...attributes}
      {...listeners}
      style={style}
      className='px-1'
      onDoubleClick={e => {
        e.stopPropagation();
        if (canEdit) {
          dispatch(setOpenModales({ id: conditionId, open: true }));
        }
      }}
    >
      <ConditionGlobal
        itemId={itemId}
        conditionId={conditionId}
        condition={condition}
        fieldInGrid={{ displayType: 'conditions' }}
        canEdit={canEdit}
      />
    </div>
  );
};
